import { render, staticRenderFns } from "./update-provider.component.vue?vue&type=template&id=d58e5008&"
import script from "./update-provider.component.vue?vue&type=script&lang=ts&"
export * from "./update-provider.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports